module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-23-min.33528ce3.jpg";